export default __webpack_public_path__ + "static/media/cabinet1-after-1440w.604132b4.avif";